"use client"

import {useEffect, useState} from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import {Button} from "@/components/ui/button"
import {useRouter} from "next/navigation";

interface EmailExistsPopupProps {
  isOpen: boolean
  onClose: () => void
}

export function EmailRegisteredPopup({ isOpen, onClose }: EmailExistsPopupProps) {
  const [open, setOpen] = useState(isOpen);
  const router = useRouter();

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  const handleClose = () => {
    setOpen(false)
    onClose()
  }

  const goToLogin = () => {
    console.log("Navigating to login page...")
    // In a real application, you would use router.push('/login')
    router.push('/login');
    handleClose()
  }

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Email has been registered successfully!</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button onClick={goToLogin}>Go to Login</Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

